import { AnalyticsGatewayService } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaAnalyticsGateway1Service = bindHTTP(AnalyticsGatewayService);
export const serviceName = 'analytics-gateway1' as const;
